import { generateCodeChallenge, generateCodeVerifier } from "@/utils/pkce";

const TENANT_ID = import.meta.env.VITE_ENTRA_TENANT_ID || "";
const CLIENT_ID = import.meta.env.VITE_ENTRA_CLIENT_ID || "";
const REDIRECT_URI = import.meta.env.VITE_ENTRA_REDIRECT_URI || "";

export const ssoService = {
  async getLoginUrl() {
    if (!TENANT_ID || !CLIENT_ID) {
      throw new Error("SSO 설정이 완료되지 않았습니다. 관리자에게 문의해 주세요.");
    }

    const verifier = generateCodeVerifier();
    localStorage.setItem("pkce_code_verifier", verifier);
    const challenge = await generateCodeChallenge(verifier);

    const baseUrl = `https://login.microsoftonline.com/${TENANT_ID}/oauth2/v2.0/authorize`;
    const params = new URLSearchParams({
      client_id: CLIENT_ID,
      response_type: "code",
      redirect_uri: REDIRECT_URI,
      scope: "openid profile email",
      code_challenge: challenge,
      code_challenge_method: "S256",
      prompt: "select_account",
    });
    return `${baseUrl}?${params.toString()}`;
  },

  async exchangeToken(code: string) {
    const verifier = localStorage.getItem("pkce_code_verifier");
    if (!verifier) {
      const hasToken = !!localStorage.getItem("admin_access_token");
      if (hasToken) {
        return null;
      }
      throw new Error("No PKCE code verifier found in local storage");
    }

    const tokenUrl = `https://login.microsoftonline.com/${TENANT_ID}/oauth2/v2.0/token`;
    const params = new URLSearchParams({
      client_id: CLIENT_ID,
      grant_type: "authorization_code",
      redirect_uri: REDIRECT_URI,
      code,
      code_verifier: verifier,
    });

    const response = await fetch(tokenUrl, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: params.toString(),
    });

    if (!response.ok) {
      localStorage.removeItem("pkce_code_verifier");
      const err = await response.json();
      throw new Error(err.error_description || "Failed to exchange token");
    }

    localStorage.removeItem("pkce_code_verifier");
    const data = await response.json();
    return { access_token: data.id_token, refresh_token: data.refresh_token };
  },
};
